import {
    AfterViewInit,
    ChangeDetectorRef,
    Component,
    ComponentRef,
    Input,
    OnDestroy,
    OnInit,
    ViewChild,
    ViewContainerRef,
    ViewEncapsulation
} from '@angular/core';
import { MatInput } from '@angular/material/input';
import { TextIconComponent } from '../../shared/text-icon/text-icon.component';
import { BaseInputComponent } from '../base-input/base-input.component';
import { TextInputType } from '../form.types';
import { QuestionStateService } from '../question-state.service';

@Component({
    selector: 'app-input',
    templateUrl: './input.component.html',
    styleUrls: ['./input.component.scss'],
    encapsulation: ViewEncapsulation.Emulated
})
export class InputComponent extends BaseInputComponent implements OnInit, AfterViewInit, OnDestroy {
    @Input() input: TextInputType;
    @ViewChild('infoTemplate', { static: true, read: ViewContainerRef }) infoTemplate: ViewContainerRef;
    @ViewChild(MatInput) inputElement: MatInput;
    hasMaxChars: boolean;
    private infoComponent: ComponentRef<TextIconComponent>;
    constructor(private questionStateService: QuestionStateService, private changeDetect: ChangeDetectorRef) {
        super();
    }

    ngOnInit(): void {
        super.initialize(this.input, this.questionStateService);
        this.hasMaxChars = this.input.maxChars > 0;
        this.input.textType = this.input.textType ? this.input.textType : 'text';
        if (this.input.info && this.infoTemplate) {
            this.infoComponent = this.infoTemplate.createComponent(TextIconComponent);
            this.infoComponent.instance.tooltip = this.input.info;
        }
    }

    ngAfterViewInit() {
        if (this.inputElement) {
            this.inputIdEvent.emit(this.inputElement.id);
        }
        this.changeDetect.detectChanges();
    }

    ngOnDestroy() {
        super.ngOnDestroy();
        if (this.infoComponent) {
            this.infoComponent.destroy();
        }
    }
}
